// Copyright 2017 Sorama B.V.

import { GenericMeasurement } from "datatypes/SoramaWebApi";
import { ProgressIndicator } from "libraries/ProgressIndicator/ProgressIndicator";

export interface IMeasurementStorageInfo {
    readonly dataOnline: boolean;
    readonly storageAllocated: boolean;
    readonly uploading: boolean;
    readonly progress: number;
}

export interface IMeasurementUploadStatus {
    readonly measurement: GenericMeasurement;

    readonly storageAllocated: boolean;
    readonly dataOnline: boolean;
    readonly dataOffline: boolean;
    readonly uploading: boolean;

    readonly totalSize: number;
    readonly uploadSize: number;

    readonly errorMessage: string;
}

export enum SyncStatus {
    Upload,
    Download,
    UploadAndDownload,
    Error,
    None,
}

export abstract class IMeasurementStorageService {
    public readonly measurementStorageInfos: { [measurementId: string]: IMeasurementStorageInfo };

    public abstract areMeasurementsAvailable(
        measurementIds: string[]
    ): Promise<{ measurementId: string; available: boolean }[]>;

    public abstract getStorageInformation(measurementId: string): Promise<IMeasurementUploadStatus>;

    public abstract setSyncStatus(
        status: SyncStatus,
        measurement: GenericMeasurement | { id: string; name: string; sorId: string }
    ): Promise<void>;

    public abstract getAvailableCloudStorage(): Promise<number>;

    public abstract registerLocalSor(
        sorId: string,
        projectId: string,
        name?: string,
        progressCallback?: (progress: ProgressIndicator) => void
    ): Promise<GenericMeasurement>;
}
